"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResponsiveTable = void 0;

var React = require("react");

var styled_components_1 = require("styled-components");

var MdKeyboardArrowUp_1 = require("@react-icons/all-files/md/MdKeyboardArrowUp");

var MdKeyboardArrowDown_1 = require("@react-icons/all-files/md/MdKeyboardArrowDown");

var react_table_1 = require("react-table");

var lodash_1 = require("lodash");

var Pagination_1 = require("./Pagination");

var blocks_1 = require("./blocks");

var LoadingPlaceholder_1 = require("./LoadingPlaceholder");

var __1 = require("../");

var utils_1 = require("../../utils");

var NoResults = styled_components_1.default.p(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  text-align: center;\n  padding: 0.8rem;\n"], ["\n  text-align: center;\n  padding: 0.8rem;\n"])));

function ResponsiveTable(_a) {
  var data = _a.data,
      columns = _a.columns,
      onRowPress = _a.onRowPress,
      _b = _a.compact,
      compact = _b === void 0 ? false : _b,
      _c = _a.loading,
      loading = _c === void 0 ? false : _c,
      _d = _a.pagination,
      pagination = _d === void 0 ? {
    pageSize: 1,
    pageIndex: 0,
    pageCount: 1
  } : _d,
      handlePageChange = _a.handlePageChange,
      handleSortChange = _a.handleSortChange,
      _e = _a.maxPageCount,
      maxPageCount = _e === void 0 ? 7 : _e,
      _f = _a.isSortable,
      isSortable = _f === void 0 ? false : _f,
      _g = _a.isPaginated,
      isPaginated = _g === void 0 ? false : _g,
      _h = _a.isStriped,
      isStriped = _h === void 0 ? false : _h,
      _j = _a.manualPagination,
      manualPagination = _j === void 0 ? true : _j,
      _k = _a.manualSorting,
      manualSorting = _k === void 0 ? true : _k,
      _l = _a.disableMultiSort,
      disableMultiSort = _l === void 0 ? true : _l,
      _m = _a.noResultsMessage,
      noResultsMessage = _m === void 0 ? 'No Results' : _m,
      disableRowClick = _a.disableRowClick,
      disableRowHover = _a.disableRowHover,
      _o = _a.showMobileHeaders,
      showMobileHeaders = _o === void 0 ? true : _o,
      _p = _a.variant,
      variant = _p === void 0 ? 'default' : _p;
  var extraHooks = [];

  if (isSortable) {
    extraHooks = __spreadArrays(extraHooks, [react_table_1.useSortBy]);
  }

  if (isPaginated) {
    extraHooks = __spreadArrays(extraHooks, [react_table_1.usePagination]);
  }

  var pageIndex = pagination.pageIndex,
      tablePageCount = pagination.pageCount,
      pageSize = pagination.pageSize;
  var windowWidth = window.innerWidth;
  var filterColumnsToDisplay = React.useMemo(function () {
    return columns.filter(function (col) {
      return (col.minDisplayWidth ? windowWidth >= col.minDisplayWidth : true) && (col.maxDisplayWidth ? windowWidth <= col.maxDisplayWidth : true);
    });
  }, [columns, windowWidth]);

  var _q = react_table_1.useTable.apply(void 0, __spreadArrays([{
    state: {
      pageIndex: pageIndex
    },
    manualPagination: manualPagination,
    pageCount: tablePageCount,
    initialState: {
      pageIndex: pageIndex,
      pageSize: pageSize
    },
    columns: filterColumnsToDisplay,
    data: data,
    manualSorting: manualSorting,
    disableMultiSort: disableMultiSort
  }], extraHooks)),
      getTableProps = _q.getTableProps,
      getTableBodyProps = _q.getTableBodyProps,
      headerGroups = _q.headerGroups,
      prepareRow = _q.prepareRow,
      page = _q.page,
      rows = _q.rows,
      state = _q.state,
      gotoPage = _q.gotoPage,
      pageCount = _q.pageCount;

  var theme = styled_components_1.useTheme();
  var themeStyles = utils_1.getComponentThemeStyles(theme, 'ResponsiveTableContainer', variant, 'default');
  var rowThemeStyles = utils_1.getComponentThemeStyles(theme, 'ResponsiveTableRow', variant, 'default');
  var containerRef = React.useRef(null);

  var _r = React.useState(0),
      containerWidth = _r[0],
      setContainerWidth = _r[1];

  var _s = React.useState(0),
      containerHeight = _s[0],
      setContainerHeight = _s[1];

  React.useEffect(function () {
    var handleResize = function handleResize() {
      var current = containerRef.current;
      var width = current ? current.offsetWidth : 0;
      var height = current ? current.offsetHeight : 0;
      setContainerWidth(width);
      setContainerHeight(height);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, [loading]);

  if (isSortable) {
    var sortByState_1 = state.sortBy[0] || {};
    React.useEffect(function () {
      var direction = sortByState_1.id ? sortByState_1.desc ? 'desc' : 'asc' : '';
      handleSortChange(sortByState_1.id || '', direction);
    }, [sortByState_1.id, sortByState_1.desc]);
  }

  var columnWidths = headerGroups[0].headers.map(function (col) {
    return col.columnWidth || 'minmax(50px, 2fr)';
  }).join(' ');

  var renderBody = function renderBody() {
    if (loading) {
      return React.createElement(blocks_1.Table.Row, {
        themeStyles: rowThemeStyles,
        disableHover: true
      }, React.createElement(LoadingPlaceholder_1.default, {
        colspan: filterColumnsToDisplay.length || 1,
        width: containerWidth,
        height: containerHeight,
        variant: variant
      }));
    }

    var rowsToMap = page ? page : rows;

    if (rowsToMap.length < 1) {
      return React.createElement(NoResults, null, noResultsMessage);
    }

    return rowsToMap.map(function (row) {
      prepareRow(row);
      return React.createElement(blocks_1.Table.Row, __assign({}, row.getRowProps(), {
        themeStyles: rowThemeStyles,
        isStriped: isStriped,
        disableClick: disableRowClick,
        disableHover: disableRowHover,
        onClick: function onClick() {
          if (lodash_1.isFunction(onRowPress)) {
            onRowPress(row);
          }
        },
        gridTemplateColumns: columnWidths
      }), row.cells.map(function (cell) {
        return React.createElement(blocks_1.Table.Column, __assign({
          compact: compact
        }, cell.getCellProps()), cell.render('Cell'));
      }));
    });
  };

  var onPageChange = function onPageChange(pageIndex) {
    gotoPage(pageIndex);
    handlePageChange(pageIndex);
  };

  var renderPagination = function renderPagination() {
    return React.createElement(Pagination_1.Pagination, {
      maxPageCount: maxPageCount,
      pageIndex: pageIndex,
      pageCount: pageCount,
      onChange: onPageChange,
      variant: variant
    });
  };

  return React.createElement(React.Fragment, null, React.createElement(blocks_1.Table.Container, __assign({
    themeStyles: themeStyles,
    role: "table"
  }, getTableProps(), {
    "aria-label": "ACG Table"
  }), React.createElement(blocks_1.Table.Header, {
    themeStyles: themeStyles,
    isStriped: isStriped,
    showMobileHeaders: showMobileHeaders
  }, headerGroups.map(function (headerGroup, i) {
    return React.createElement(blocks_1.Table.Row, __assign({
      key: i,
      disableHover: true
    }, headerGroup.getHeaderGroupProps(), {
      gridTemplateColumns: columnWidths
    }), headerGroup.headers.map(function (column, i) {
      var isSortEnabled = isSortable && column.canSort;
      var sortProps = {
        style: {
          cursor: 'pointer'
        },
        onClick: function onClick() {
          column.toggleSortBy();
        }
      };
      var props = isSortEnabled ? sortProps : {};
      return React.createElement(blocks_1.Table.Heading, __assign({
        key: i,
        compact: compact
      }, column.getHeaderProps(), props), React.createElement(__1.Block, {
        display: "flex",
        alignItems: "center"
      }, React.createElement("div", null, column.render('Header')), column.canSort && column.isSortedDesc !== undefined && React.createElement(__1.Block, {
        height: "16px"
      }, React.createElement(column.isSortedDesc ? MdKeyboardArrowDown_1.MdKeyboardArrowDown : MdKeyboardArrowUp_1.MdKeyboardArrowUp, {
        size: 20
      }))));
    }));
  })), React.createElement("tbody", __assign({}, getTableBodyProps(), {
    ref: containerRef
  }), renderBody())), isPaginated && renderPagination());
}

exports.ResponsiveTable = ResponsiveTable;
var templateObject_1;